import ParametragesVisitesPostes from '@/views/mdt/parametrages' 
import ParamVisiteMedicale from '@/views/mdt/societe/societeDetails/parametrages-visites-medicales'
import ProgramVisiteMedicale from '@/views/mdt/societe/societeDetails/visites-medicales'
import moment from 'moment'
export default {
  name: 'parametrages',
  components: {
    ParametragesVisitesPostes,ParamVisiteMedicale,ProgramVisiteMedicale
  },
  props: [],
  data () {
    return {
      section_selected: {
        id: 1,
        label :"Visites médicales annuelles",
        value: "vma"
      },
      sections: [
        {
          id: 1,
          label :"Visites médicales annuelles",
          value: "vma"
        },
        {
          id: 2,
          label :"Visites de postes",
          value: "vp"
        }
      ]
    }
  },
  computed: {
    year(){
      if(this.latestVisiteEnCours.date_debut != undefined){
       return moment(this.latestVisiteEnCours.date_debut).year()
      }else {
        return ""
      }
      
    },
    latestVisiteEnCours(){
      return this.$store.getters["latestVisiteMedicaleAnnuelle"]
    },
    showProg(){
      
      if(Object.keys(this.latestVisiteEnCours).length ===0) {
        return false
      } else{
        return true
      }
    },
    programmations() {
      return this.$store.getters["currentProgrammationLists"]
    },
  },
  mounted () {
    

  },
  methods: {

  }
}


